/**
 * Centralized metadata for the 5 max types an exercise can track.
 * Used by both the coach Exercise form (dropdown) and the athlete-side
 * max-input editor (unit suffix + step size).
 */
import { Dumbbell, Timer, Gauge, Activity, ArrowUp } from "lucide-react";

export const MAX_TYPE_META = {
    weight_lbs:    { label: "Weight",     unit: "lbs", step: 5,   icon: Dumbbell, dropdownLabel: "Weight (in lbs)" },
    time_secs:     { label: "Time",       unit: "sec", step: 1,   icon: Timer,    dropdownLabel: "Time (in Secs)" },
    speed_mph:     { label: "Speed",      unit: "mph", step: 0.1, icon: Gauge,    dropdownLabel: "Speed (in MPH)" },
    resistance:    { label: "Resistance", unit: "lvl", step: 1,   icon: Activity, dropdownLabel: "Resistance" },
    height_inches: { label: "Height",     unit: "in",  step: 0.5, icon: ArrowUp,  dropdownLabel: "Height (in Inches)" },
};

export const MAX_TYPE_OPTIONS = [
    "weight_lbs",
    "time_secs",
    "speed_mph",
    "resistance",
    "height_inches",
];

export const MAX_INPUT_LABEL = (type) => {
    const m = MAX_TYPE_META[type];
    if (!m) return type;
    return `${m.label} (${m.unit})`;
};
